import React, { useState, useEffect, useContext, PropsWithChildren } from "react";
import { AnalyticsGroupBy } from "api/types";

export interface BannerConfig {
  title?: string;
  description?: string;
  dismissable?: boolean;
  severity?: string;
  renderOnlyInTheseRoutes?: string[];
  renderInErrorPages?: boolean;
}

interface Config {
  pages:
    | {
        portfolio:
          | {
              overview:
                | {
                    piechart:
                      | {
                          groupBy: AnalyticsGroupBy | undefined;
                          groupCode: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              modelPortfolio:
                | {
                  showModelPortfolioDescription: boolean | undefined;
                  descriptions: {
                    [key: string]: {
                      name: string | undefined;
                      description: string | undefined;
                    }
                  }
                | undefined;
                  }
            }
          | undefined;
      }
    | undefined;
  banner?: BannerConfig;
}

export const ConfigContext = React.createContext<Config | null>(null);

export const ConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    fetch("/config/config.json", { cache: "no-store" })
      .then((response) => response.json())
      .catch((error) => console.error(error))
      .then((json) => setConfig(json));
  }, []);

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const config = useContext(ConfigContext);
  return config;
};
